import { Box, BoxProps, styled, SxProps, Theme } from '@mui/material';
import { FC, MouseEventHandler, useMemo } from 'react';

import { IHasChildren } from './types/IHasChildren';

export const StyledDropdownName = "MuiDropdown"

export type MuiDropdownComponent = { 
    MuiDropdown: {
        defaultProps?: IDropdownProps;
        styleOverrides?: { root: Record<string, unknown> }
        variants?: undefined
    } 
}

interface IDropdownProps extends IHasChildren {
    anchor: HTMLElement | null;
    open: boolean;
    position?: 'bottom' | 'left' | 'right',
    sx?: SxProps<Theme>;
    onClick?: MouseEventHandler | undefined;
}

interface IDropdownState extends IDropdownProps {}

const StyledDropdown = styled(Box, { name: StyledDropdownName, slot: 'root' })<BoxProps & { ownerState?: IDropdownState, open: boolean, pos: any }>(({ open, pos }) => ({
    position: 'absolute',
    top: pos.top,
    left: pos.left,
    right: pos.right,
    bottom: pos.bottom,
    display: open ? 'block' : 'none',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'    
}))

const Dropdown: FC<IDropdownProps> = ({
    anchor,
    open,
    position,
    sx,
    onClick,
    children
}) => {

    const bounds = anchor?.getBoundingClientRect();

    const pos = useMemo(() => {
        switch (position) {
            case 'bottom':
            case undefined:
                return {
                    top: bounds?.height ?? '0px',
                    right: undefined,
                    left: '0px',
                    bottom: undefined
                }
                
            case 'left':
                return {
                    top: '0px',
                    right: bounds?.width ?? '100%',
                    left: undefined,
                    bottom: undefined
                }
            default: 
                return {
                    top: bounds?.height ?? '0px',
                    right: undefined,
                    left: '0px',
                    bottom: undefined
                }
                
        }
    }, [position, bounds]);

    return (
        <StyledDropdown
            sx={{
                ...sx
            }}
            open={open}
            pos={pos}
            onClick={onClick}
        >
            {children}
        </StyledDropdown>
    )
}

export default Dropdown